module.exports = __webpack_public_path__ + "img/Apps_detail.1cba9686.png";